'use strict';

class IdenticalInternationalEdit {
  constructor($scope, $location, $routeParams, $filter, commonService, invoiceService, originatorService, labelService, recipientService, StoreService, userService, Notification) {
    this.$scope = $scope;
    this.$location = $location;
    this.$filter = $filter;
    this.commonService = commonService;
    this.invoiceService = invoiceService;
    this.originatorService = originatorService;
    this.labelService = labelService;
    this.recipientService = recipientService;
    this.userService = userService;
    this.Notification = Notification;
    this.recipientPreviewVisible = false;
    this.number = $routeParams.number;

    this.recipients = new StoreService();

    this.availableLabels = new StoreService();
    this.includedLabels = new StoreService();
    this.excludedLabels = new StoreService();

    this.availableRecipients = new StoreService();
    this.includedRecipients = new StoreService();
  }

  $onInit() {
    this.displayContractNumber = false;
    this.displayProjectReference = false;
    this.accountNumbers = [];

    this.taxEnabled = false;
    this.summaryCalculated = false;
    this.summary = {
      net: [],
      tax: [],
      total: 0,
      taxRates: []
    };

    this.taxRates = [];

    this.currencies = [{
      code: 'NOK',
      name: 'Norske kroner',
      rate: 1
    }];

    this.currency = this.currencies[0];

    this.i18n = {
      QUANTITY: 'Quantity',
      CODE: 'Product',
      DESCRIPTION: 'Description',
      UNITPRICE: 'Price',
      DISCOUNT: 'Disc. %',
      TAXRATE: 'VAT',
      TOTAL: 'Sum'
    };

    this.countries = ['NORGE'];

    this.commonService.getCountries()
      .then((resp) => {
        this.countries = resp;
      });

    this.commonService.getExchangeRates()
      .then((resp) => {
        this.currencies = resp;
      });

    // get taxRates
    this.commonService.getConstants()
      .then((resp) => {
        this.taxRates = resp.taxRates;
        // let ar = Array.apply(null, new Array(this.taxRates.length)).map(Number.prototype.valueOf, 0);
        let l = this.taxRates.length;

        let net = Array.apply(null, new Array(l)).map(Number.prototype.valueOf, 0);
        let tax = Array.apply(null, new Array(l - 1)).map(Number.prototype.valueOf, 0);

        if (!this.summaryCalculated) {
          this.summary = {
            net: net,
            tax: tax,
            total: 0,
            taxRates: this.taxRates
          };
        }
      });

    this.originator = {};
    this.identical = {
      name: `Masseutsendelse ${moment().format('DD.MM.YY HH:mm')}`,
      comment: null,
      invoice: {
        invoiceDate: moment().format('YYYY-MM-DD'),
        accountNumber: null,
        dueDate: moment().format('YYYY-MM-DD'),
        orderDate: null,
        orderNumber: null,
        ourReference: null,
        invoiceText: null,
        items: []
      },
      customMessage: null,
      recipients: this.recipients.get(),
      shipment: {
        preferred : 'email'
      }
    };

    // datepicker
    this.commonService.datePicker({
      field: $('#dueDate')[0]
    });

    this.commonService.datePicker({
      field: $('#orderDate')[0]
    });

    // Count all the available recipients
    this.allRecipientSelected = false;
    this.recipientsCount = 0;
    this.recipientService.list({
      offset: 0,
      limit: 10000
    })
      .then((resp) => {
        this.recipientsCount = resp.data.total;
      });

    // load original document
    let draftNumber = this.$location.search().kladd;

    if (this.number !== 'ny' && !isNaN(parseInt(this.number, 10))) {
      this.load(this.number, 'identical');
    } else if (draftNumber && !isNaN(parseInt(draftNumber, 10))) {
      this.load(draftNumber, 'draft');
    }

    this.loadOriginator();
    this.loadLabels();

    this.$scope.$on('productList', (e, val) => {
      if (val) {
        this.identical.invoice.items = val;
      }
    });

    this.$scope.$on('productSummary', (e, val) => {
      if (val) {
        this.summaryCalculated = true;
        this.summary = val;
      }
    });

    this.$scope.$watch('$ctrl.identical.invoice.accountNumber', (val, old) => {
      if (val && val !== old) {
        this.accountNumbers.forEach((item) => {
          if (val === item.number) {
            if (this.identical.invoice.international) {
              this.identical.invoice.international.bic = item.bic;
              this.identical.invoice.international.iban = item.iban;
            } else {
              this.identical.invoice.international = {
                bic: item.bic,
                iban: item.iban
              };
            }
            //do not display on page load
            if (old !== null) {
              this.Notification.success('BIC/IBAN er oppdatert');
            }
          }
        });
        this.updateGiro();
      }
    });

    this.$scope.$watchGroup([
      '$ctrl.identical.invoice.invoiceDate',
      '$ctrl.identical.invoice.dueDate',
      // '$ctrl.identical.invoice.accountNumber',
      '$ctrl.summary'
    ], (val, old) => {
      if (val !== old) {
        this.updateGiro();
      }
    });

    this.$scope.$watch('$ctrl.currency.code', (val) => {
      if (val === 'NOK') {
        this.identical.invoice.currency = val;
        if (this.identical.invoice.international) {
          this.identical.invoice.international.exchangeRate = 1;
        } else {
          this.identical.invoice.international = {
            exchangeRate: 1
          };
        }
      } else {
        this.currencies.forEach((currency) => {
          if (val === currency.code) {
            // update invoice
            this.identical.invoice.currency = currency.code;

            if (this.identical.invoice.international) {
              this.identical.invoice.international.exchangeRate = currency.rate;
            } else {
              this.identical.invoice.international = {
                exchangeRate: currency.rate
              };
            }
            return true;
          }
        }, this);
      }
    });
  }

  updateAccountNumberOnInvoice() {
    if (this.originator && !this.$filter('isEmptyObject')(this.originator)) {
      let found = this.accountNumbers.some(an => an.number === this.identical.invoice.accountNumber);
      if (this.identical.invoice.accountNumber === null || !found) {
        this.identical.invoice.accountNumber = this.originator.bankAccount.number;
      }
    }
  }

  updateAccountOnOriginatorForDisplay() {
    if (this.identical.invoice && this.originatorForDisplay) {
      this.originatorForDisplay.bankAccount.number = this.identical.invoice.accountNumber;
    }
  }

  /**
   * Load a specific document
   *
   * @param {Number} number Number of the document
   * @param {String} type Document to load
   */
  load(number, type = 'draft') {
    if (type === 'draft') {
      this.invoiceService.getDraft(number)
        .then((resp) => {
          angular.extend(this.identical.invoice, {
            invoiceDate: resp.data.invoiceDate,
            dueDate: resp.data.dueDate,
            orderDate: resp.data.orderDate,
            orderNumber: resp.data.orderNumber,
            ourReference: resp.data.ourReference,
            invoiceText: resp.data.invoiceText,
            items: resp.data.items
          });
          this.updateAccountNumberOnInvoice();
        });
    } else if (type === 'identical') {
      this.invoiceService.getIdenticalInvoice(number)
        .then((resp) => {
          angular.extend(this.identical, {
            name: resp.data.name,
            comment: resp.data.comment
          });
          this.updateAccountNumberOnInvoice();
        })
        .then(() => {
          // add recipients from identical
          this.invoiceService.getIdenticalRecipients(number)
            .then((recipients) => {
              if (recipients.data.length) {
                recipients.data.forEach((r) => {
                  if (!r.deleted) {
                    this.recipients.add({
                      name: r.name,
                      number: r.number
                    });
                  }
                }, this);
              }
            });
        });
    }
  }

  calc(items) {
    let total = 0;

    items.forEach((i) => {
      total += i;
    });

    return total;
  }

  /**
   * Load originator's data
   */
  loadOriginator() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        if (this.identical.invoice.international) {
          this.identical.invoice.international.bic = resp.data.bankAccount.bic;
          this.identical.invoice.international.iban = resp.data.bankAccount.iban;
        } else {
          this.identical.invoice.international = {
            bic: resp.data.bankAccount.bic,
            iban: resp.data.bankAccount.iban
          };
        }

        this.accountNumbers = [];
        this.accountNumbers.push(
          {
            number: this.originator.bankAccount.number,
            bic: this.originator.bankAccount.bic,
            iban: this.originator.bankAccount.iban
          }
        );
        if (this.originator.bankAccount.additionalBankAccounts && this.originator.bankAccount.additionalBankAccounts.length > 0) {
          this.originator.bankAccount.additionalBankAccounts.forEach((a) => {
            this.accountNumbers.push(a);
          });
        }

        this.updateAccountNumberOnInvoice();
        this.originatorForDisplay = angular.copy(this.originator);
        this.updateAccountOnOriginatorForDisplay();
        this.updateGiro();
      });

    this.originatorService.settings()
      .then((resp) => {
        this.taxEnabled = resp.data.defaults.totalIncludeMva;
        this.displayContractNumber = resp.data.defaults.displayContractNumber;
        this.displayProjectReference = resp.data.defaults.displayProjectReference;
        this.identical.invoice.dueDate = moment().add(resp.data.defaults.invoice.dueDays, 'days').format('YYYY-MM-DD');
        this.identical.invoice.invoiceText = resp.data.defaults.invoice.text;
        if (this.identical.invoice.ourReference === null) {
          this.identical.invoice.ourReference = resp.data.defaults.invoice.ourRef;
        }
      });
  }

  /**
   * Load the label list
   */
  loadLabels() {
    this.labelService.list()
      .then((resp) => {
        if (resp.data && resp.data.length) {
          resp.data.forEach((label) => {
            if (label.membersTotal > 0) {
              this.availableLabels.add(label);
            }
          }, this);
        }
      });
  }

  /**
   * Include a label
   *
   * @param {Object} label A label to include
   */
  includeLabel(label) {
    this.excludedLabels.remove(label);
    this.availableLabels.remove(label);
    this.includedLabels.add(label);

    this.resolveLabels();
  }

  allNetZero() {
    let sum = this.summary.net.reduce(function(a, b) { return a + b; }, 0);
    let x = (sum === 0);
    return x;
  }

  /**
   * Exclude a label
   *
   * @param {Object} label Exclude a label
   */
  excludeLabel(label) {
    this.includedLabels.remove(label);
    this.availableLabels.remove(label);
    this.excludedLabels.add(label);

    // this.removeLabelRecipients(label.number);

    this.resolveLabels();
  }

  /**
   * Remove a label from a group
   *
   * @param {Object} label Label to remove from a group
   */
  removeLabel(label) {
    this.includedLabels.remove(label);
    this.excludedLabels.remove(label);
    this.availableLabels.add(label);

    this.resolveLabels();
    //this.removeLabelRecipients(label.number);
  }

  /**
   * Remove all recipients by the given label
   *
   * @param {Integer} labelNumber Number of the label
   */
  // removeLabelRecipients(labelNumber) {
  //   this.labelService.members(labelNumber)
  //     .then((resp) => {
  //       if (resp.data && resp.data.items.length) {
  //         resp.data.items.forEach((recipient) => {
  //           this.recipients.remove({
  //             number: recipient.recipientNumber
  //           });
  //         }, this);
  //       }
  //     });
  // }

  /**
   * Resolve included and excluded labels to recipients
   */
  resolveLabels() {
    let params = {
      offset: 0,
      limit: 1000
    };

    this.recipients.reset();

    if (this.includedLabels.length()) {
      //don't add included labels if all recipients selected (number 0)
      if (this.allRecipientSelected === false) {
        params.labels = this.includedLabels.get().map((l) => l.number).join(',');
      }
    }

    if (this.excludedLabels.length()) {
      params.excludedLabels = this.excludedLabels.get().map((l) => l.number).join(',');
    }

    if (this.includedLabels.length() > 0 || this.excludedLabels.length() > 0 || this.allRecipientSelected === true) {
      this.recipientService.list(params)
        .then((resp) => {
          resp.data.recipient.forEach((recipient) => {
            this.recipients.add({
              number: recipient.number,
              name: recipient.name,
              customerNumber: recipient.customerNumber
            });
          }, this);
          this.addManualRecipients();
          this.identical.recipients = this.recipients.get();
        });
    } else {
      this.recipients.reset();
      this.addManualRecipients();
      this.identical.recipients = this.recipients.get();
    }
  }

  /**
   * Search for recipient
   */
  searchRecipient() {
    if (this.term) {
      this.recipientService.search(this.term, 100)
        .then((resp) => {
          this.availableRecipients.reset();
          resp.data.recipients.forEach((recipient) => {
            this.availableRecipients.add({
              number: recipient.number,
              name: recipient.name,
              customerNumber: recipient.recipientNo
            });
          }, this);
        });
    } else {
      this.availableRecipients.reset();
    }
  }

  /**
   * Load recipient list and include all
   */
  includeAllRecipients() {
    this.recipientService.list({
      offset: 0,
      limit: 10000
    })
      .then((resp) => {
        if (resp.data && resp.data.recipient && resp.data.recipient.length) {
          resp.data.recipient.forEach((recipient) => {
            this.recipients.add({
              number: recipient.number,
              name: recipient.name,
              customerNumber: recipient.customerNumber
            });

            this.allRecipientSelected = true;
          }, this);
        }
      });
  }

  /**
   * Remove all recipients
   */
  removeAllRecipients() {
    this.recipients.reset();
    this.includedRecipients.reset();
    this.identical.recipients = this.recipients.get();
    this.allRecipientSelected = false;
  }

  /**
   * Include a recipient
   *
   * @param {Object} recipient Recipient to include
   */
  includeRecipient(recipient) {
    angular.extend(recipient, {
      locked: true
    });

    this.includedRecipients.add(recipient, true);
    // this.recipients.add(recipient, true);

    this.availableRecipients.reset();
    this.term = null;

    this.addManualRecipients();
    // this.resolveRecipients();
  }

  /**
   * Remove a recipient from a group
   *
   * @param {Object} recipient Recipient to remove
   */
  removeRecipient(recipient) {
    this.recipients.remove(recipient, true);
    this.includedRecipients.remove(recipient, true);

    this.availableRecipients.reset();
    this.term = null;

    // this.resolveRecipients();
  }

  /**
   * Create a new label with the individually added recipients
   */
  createLabel() {
    if (this.name && this.name !== null) {
      this.labelService.create(this.name)
        .then((resp) => {
          const nr = this.$filter('urlParser')(resp.headers('Location'), 5);
          const name = this.name;
          this.name = null;

          if (nr && nr !== null) {
            this.recipients.get().forEach((recipient) => {
              this.labelService.assignMember(nr, recipient.number)
                .then(() => {
                  this.includedLabels.add({
                    number: nr,
                    name: name,
                    membersTotal: this.includedRecipients.length()
                  });
                });
            }, this);
          }
        });
    }
  }

  /**
   * Resolve individual recipients
   */
  resolveRecipients() {
    // add individual recipients
    if (this.includedRecipients.length()) {
      this.includedRecipients.get().forEach((recipient) => {
        angular.extend(recipient, {
          locked: true
        });

        this.recipients.add(recipient, true);
      }, this);
    }
  }

  addManualRecipients() {
    this.includedRecipients.get().forEach((element) => {
      let findIndex = this.recipients.get().findIndex((item) => item.number === element.number);
      if (findIndex < 0) {
        this.recipients.add(element, true);
      }
    });
  }

  /**
   * Update canvas giro
   */
  updateGiro() {
    this.canvasData = {
      invoiceNumber: '---',
      invoiceDate: moment(this.identical.invoice.invoiceDate, 'YYYY-MM-DD').format('DD.MM.YY'),
      total: this.summary.total,
      dueDate: moment(this.identical.invoice.dueDate, 'YYYY-MM-DD').format('DD.MM.YY')
    };

    if (this.originator && this.originator.contact && this.originator.bankAccount) {
      //update accountno on originator
      this.updateAccountOnOriginatorForDisplay();

      angular.extend(this.canvasData, {
        accountNumber: this.identical.invoice.accountNumber,
        originator: {
          name: this.originator.name || '',
          address1: this.originator.contact.address.address1 || '',
          address2: this.originator.contact.address.address2 || '',
          zipCity: this.originator.contact.address.zip + ' ' + this.originator.contact.address.city || '',
          country: this.originator.contact.address.country || '',
          kid: this.originator.bankAccount.kid && this.originator.bankAccount.number === this.identical.invoice.accountNumber || false
        }
      });
    }
  }

changeLanguage() {
    swal({
      title: 'Bytt til engelsk faktura?',
      text: 'Du vil miste det du har skrevet på denne regningen.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0c4d91',
      confirmButtonText: 'Ok',
      cancelButtonText: 'Avbryt',
      closeOnConfirm: true
    }, (answer) => {
      if (answer) {
            if (this.originator.giroLayout) {
              this.$scope.$apply(() => this.$location.path('/masseutsendelse/ny'));
            } else {
              this.$scope.$apply(() => this.$location.path('/masseutsendelse/utengiro/ny'));
            }
      }
    });
  }

  /**
   * Save and send identical
   */
  save() {
    if (this.identical.recipients.length) {
      // cleanup items
      if (this.identical.invoice.items.length) {
        this.identical.invoice.items.forEach((item) => {
          item.unitPrice = this.$filter('defaultValue')(this.$filter('numberify')(item.unitPrice), null);
          item.quantity = this.$filter('defaultValue')(this.$filter('numberify')(item.quantity), null);
          return item;
        }, this);
      }

      swal({
        title: `Du er nå i ferd med å sende ${this.identical.recipients.length} regning(er)`,
        text: [
          'Regningene vil bli sendt på følgende måter:',
          '<ol class="indent-list">',
          '<li> E-post eller papir, basert på valg i feltet “Foretrukket forsendelsesmåte”.</li>',
          '</ol>',
          '        <fieldset>' +
          '          <label for="customMessage">Melding til mottager (Kun for e-post-forsendelser)</label>' +
          '          <textarea id="customMessage" class="no-resize" cols="30" rows="10"></textarea>' +
          '        </fieldset>'
        ].join(''),
        html: true,
        showCancelButton: true,
        confirmButtonColor: '#2ba6cb',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nei',
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }, (answer) => {
        if (answer) {
          let cm = document.getElementById('customMessage').value;
          // let cm2 = angular.element('#customMessage').val();
          if (cm) {
            this.identical.customMessage = cm;
          }

          //No longer do that because additional accountno might be selected
          // Update originator
          // if (this.identical.invoice.international && this.identical.invoice.international.bic && this.identical.invoice.international.iban) {
          //   this.originator.bankAccount.iban = this.identical.invoice.international.iban;
          //   this.originator.bankAccount.bic = this.identical.invoice.international.bic;
          //
          //   this.originatorService.update(this.originator);
          // }

          this.invoiceService.sendIdenticalInvoice(this.identical)
            .then(() => {
              swal.close();
              this.$location.path('/masseutsendelse');
            })
            .catch(() => {
              swal.close();
            });
        }
      });
    }
  }
  keyboardActions($event) {
    if (this.recipientPreviewVisible) {
      if ($event.keyCode === 27) {
        this.closeRecipientPreview();
      }
    }
  }

  closeRecipientPreview() {
    let modal = document.querySelector('.recipient-list-modal');
    modal.style.display = 'none';
    this.recipientPreviewVisible = false;
  }

  recipientPreview() {
    let modal = document.querySelector('.recipient-list-modal');
    modal.style.display = 'block';

    this.recipientPreviewVisible = true;
  }
}

IdenticalInternationalEdit.$inject = ['$scope', '$location', '$routeParams', '$filter', 'commonService', 'invoiceService', 'originatorService', 'labelService', 'recipientService', 'StoreService', 'userService', 'Notification'];

const identicalInternationalEdit = {
  controller: IdenticalInternationalEdit,
  templateUrl: 'invoice/identical/edit-international.html'
};

angular
  .module('SendRegning')
  .component('identicalInternationalEdit', identicalInternationalEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/masseutsendelse/engelsk/:number', {
        title: 'Masseutsendelse',
        template: '<identical-international-edit />',
        secure: true,
        noSidebar: true
      });
  });
